import React, {useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { sendNewsletterEmailRequest } from "store/actions";
import toastr from "toastr"

const Stayintheloop = () => {
  const [email, setEmail] = useState('')
  const [isValid, setIsValid] = useState(true);
  const dispatch = useDispatch()


  const handleChange = (email) => {
    setEmail(email)
    let isValidEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    setIsValid(isValidEmail);
  }
  const handleSubscribe = () => {
    if (email === '') {
      return toastr.error("Email is required");
    }
    if (!isValid) {
      return toastr.error("Please enter a valid Email");
    }
    let body = {}
    body.email = email
    body.marketPlace = true
    const callback = (res) => {
      if (res?.status === "success") {

        setEmail("")
        if(res?.data==="Email already Verified for NewsLetter"){
          return toastr.error("Your email address has been whitelisted for the newsletter")
        }
        return toastr.success("We have sent a verification email to your inbox. Please follow the instructions to confirm your subscription to our newsletter.")
      }
    }
    dispatch(sendNewsletterEmailRequest(body, callback))
  }

  return (
    <div className=" container-fluid stayinthe">

      <Container>
        <Row>
          <Col lg="5">
            <img src={'/images/png/stayinloop.png'} className="stayimg" alt="" />
          </Col>
          <Col className="my-auto" lg="7">
            <div className="stayintext text-start">
              <h4>Stay in the loop</h4>
              <p>Stay informed about our newest features, Digital Artwork, and invaluable tips for navigating the Terpnash Art Marketplace.</p>
              <div className="subscribeBox">
                <input type="text" placeholder="Your email address" value={email} onChange={(e) => handleChange(e.target.value)} />

                <button onClick={handleSubscribe} >Subscribe</button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

    </div>
  );
};

export default Stayintheloop;
